import { render, staticRenderFns } from "./freeDelivery.vue?vue&type=template&id=861bee26&scoped=true"
import script from "./freeDelivery.vue?vue&type=script&lang=js"
export * from "./freeDelivery.vue?vue&type=script&lang=js"
import style0 from "./freeDelivery.vue?vue&type=style&index=0&id=861bee26&prod&lang=css"
import style1 from "./freeDelivery.vue?vue&type=style&index=1&id=861bee26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861bee26",
  null
  
)

export default component.exports